import { Flex, IconButton, InputContainer, Menu, MinusCircleIcon, TextField } from 'components'
import { startCase } from 'lodash-es'
import { LookupOutputProp, LookupOutputProps } from 'types'

interface AdditionalMappingProps {
  rowKey: number
  disabled?: boolean
  dbInputProps: string[]
  lookupOutputProps: LookupOutputProp[]
  updateOutputProps: (props: LookupOutputProps) => void
  dbFields: string[]
  handleRemoveRow: (rowId: number) => void
  inputFieldCheck: (value: string) => void
}

export default function SmartColumnAdditionalMapping({
  rowKey,
  disabled,
  dbInputProps,
  lookupOutputProps,
  updateOutputProps,
  dbFields,
  handleRemoveRow,
  inputFieldCheck,
}: AdditionalMappingProps) {
  return (
    <Flex gap={5} ml={{ base: 'auto', lg: '314px' }} h="65px" align="flex-end">
      <Menu
        variant="outline"
        menuProps={{
          positioning: { sameWidth: true },
        }}
        w={optionWidths}
        borderRadius="10px"
        label="Mapped Field"
        disabled={disabled}
        buttonLabel={lookupOutputProps.find(row => row.index === rowKey)?.dbField ?? ''}
        options={dbFields
          ?.filter(
            key => !lookupOutputProps.some(row => row.dbField === key) && !dbInputProps.includes(key)
          )
          .map(property => ({
            type: 'item',
            label: startCase(property),
            value: property,
          }))}
        onChange={value => {
          updateOutputProps({ index: rowKey, updateOn: 'field', dbField: value })
        }}
      />
      <InputContainer label="New Mapped Field Name" px={1}>
        <TextField
          size="sm"
          h="40px"
          disabled={!lookupOutputProps[0] || disabled}
          w={optionWidths}
          borderRadius="10px"
          placeholder="Enter field name..."
          onChange={e =>
            updateOutputProps({
              index: rowKey,
              updateOn: 'fieldName',
              fieldName: e.target.value,
            })
          }
          onBlur={e => inputFieldCheck(e.target.value)}
        />
      </InputContainer>

      <IconButton
        aria-label="remove-mapping"
        bg=""
        disabled={disabled}
        icon={<MinusCircleIcon type="outline" color="red" fontSize="md" />}
        onClick={() => handleRemoveRow(rowKey)}
      />
    </Flex>
  )
}

const optionWidths = { base: '100%', lg: '250px' }
